export default __webpack_public_path__ + "static/media/VendorsTab.2b3b5231.xlsx";